import type { Texture } from "pixi.js";
import { Assets, BitmapFont, bitmapFontXMLStringParser } from "pixi.js";

const mapLabelFontUrl = new URL("./fonts/MavenPro-Bold.fnt", import.meta.url)
    .href;

const mapLabelFontTextureUrl = new URL(
    "./fonts/mavenpro-bold-msdf.png",
    import.meta.url,
).href;

let mapLabelFontPromise: Promise<BitmapFont> | undefined;

export function loadMapLabelFont(): Promise<BitmapFont> {
    if (!mapLabelFontPromise) {
        mapLabelFontPromise = Promise.all([
            fetch(mapLabelFontUrl).then(async (response) => {
                if (!response.ok) {
                    throw new Error(
                        `Font metadata load failed: ${response.status} ${response.statusText}`,
                    );
                }

                return bitmapFontXMLStringParser.parse(await response.text());
            }),
            Assets.load<Texture>({
                src: mapLabelFontTextureUrl,
                data: {
                    scaleMode: "linear",
                    alphaMode: "premultiply-alpha-on-upload",
                    autoGenerateMipmaps: false,
                    resolution: 1,
                },
            }),
        ]).then(([data, texture]) => {
            const bitmapFont = new BitmapFont(
                { data, textures: [texture] },
                mapLabelFontUrl,
            );

            Assets.cache.set(data.fontFamily, bitmapFont);

            return bitmapFont;
        });
    }

    return mapLabelFontPromise;
}
